import { Modal } from 'almanac-ui/Modal'
import { DatabaseModeRow } from './DatabaseModeRow'
import { HandbookModeRow } from './HandbookModeRow'
import { Preferences } from './Preferences'
import { DocumentationSettingsProps } from './Types'

export const Documentation = ({ handbook, onUpdate, isUpdating }: DocumentationSettingsProps) => {
  const isHandbook = !handbook.folder?.database_mode

  return (
    <>
      <Modal.Content>
        <DatabaseModeRow handbook={handbook} />
        {isHandbook && <HandbookModeRow handbook={handbook} />}
        <Preferences handbook={handbook} onUpdate={onUpdate} isUpdating={isUpdating} />
      </Modal.Content>
    </>
  )
}
